import { inject, Injectable } from '@angular/core';
import { GetUserNotifications } from 'app/layout/common/notifications/user-notifications/get-user-notifications';
import { UserNotificationsResponse } from 'app/layout/common/notifications/user-notifications/user-notification-types';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class GetUserNotificationsService {
    private _getUserNotificationsService = inject(GetUserNotifications);

    execute(isPaginated: boolean, page:number): Observable<UserNotificationsResponse> {
        return this._getUserNotificationsService.execute(isPaginated, page);
    }
}
